// @ts-nocheck
import {
    HasProductContext,
    ProductContextModel,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import Plus from "@store/Library/Components/Toolkit/Icons/Plus";
import Button, { ButtonPresentationProps } from "@store/MobiusOverrides/Button/Button";
import Link, { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import RelatedProductsModal from "@store/Library/Components/RelatedProductsModal";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { MutableRefObject, useEffect, useState } from "react";
import { css } from "styled-components";

export interface RelatedProductsButtonProps extends Omit<OwnProps, keyof ButtonPresentationProps> {}

interface OwnProps {
    extendedStyles?: RelatedProductsButtonStyles;
    relatedProductsButtonOverridedStyles?: RelatedProductsButtonStyles;
    modalHeader: string;
    label: string;
    emptyMessage: string;
    productRelation: string;
    productId: string;
    showAsLink?: boolean;
    useQuickOrderUxBehavior?: boolean;
    dynamicDropdownRef?: MutableRefObject<HTMLDivElement | null>;
}

type Props = OwnProps & HasProductContext;
export interface RelatedProductsButtonStyles {
    button?: ButtonPresentationProps;
    link?: LinkPresentationProps;
}

export const relatedProductsButtonStyles: RelatedProductsButtonStyles = {
    button: {
        buttonType: "outline",
        variant: "primary",
        css: css`
            ${x => x.theme.button.primary.css}
            flex: 1 0 auto;
            align-self: flex-end;
        `,
    },
    link: linkGetActionLinkProps(Plus),
};

const getProductContextId = (productContext: ProductContextModel) => {
    const {
        product: { id },
    } = productContext;
    return id;
};

const RelatedProductsButton = ({
    modalHeader,
    label,
    productRelation,
    emptyMessage,
    productId,
    productContext,
    extendedStyles,
    relatedProductsButtonOverridedStyles,
    showAsLink,
    useQuickOrderUxBehavior,
    dynamicDropdownRef,
}: Props) => {
    const [isSimilarProductsOpen, setIsSimilarProductsOpen] = useState(false);
    const similarProductsButtonRef = React.createRef<HTMLButtonElement>();
    const handleRelatedProductsModalClose = () => {
        setIsSimilarProductsOpen(false);
        if (useQuickOrderUxBehavior && dynamicDropdownRef && dynamicDropdownRef.current) {
            setTimeout(() => {
                const productInputElement = (dynamicDropdownRef.current as any).input?.current?.querySelector("input");
                const clearButtonElement = productInputElement?.parentElement?.querySelector("button");
                clearButtonElement.click();
                productInputElement.focus();
            }, 150);
        }
    };
    const styles = useExpandProps(relatedProductsButtonStyles, extendedStyles, relatedProductsButtonOverridedStyles);
    const modalProductId = productId || getProductContextId(productContext);

    useEffect(() => {
        if (useQuickOrderUxBehavior && similarProductsButtonRef && similarProductsButtonRef.current) {
            similarProductsButtonRef.current?.focus();
        }
    }, []);

    return (
        <>
            {showAsLink ? (
                <Link
                    {...styles.link}
                    onClick={() => {
                        setIsSimilarProductsOpen(true);
                    }}
                >
                    {label}
                </Link>
            ) : (
                <Button
                    {...styles.button}
                    onClick={() => {
                        setIsSimilarProductsOpen(true);
                    }}
                    ref={similarProductsButtonRef}
                >
                    {label}
                </Button>
            )}
            <RelatedProductsModal
                productRelation={productRelation}
                modalHeader={modalHeader}
                emptyMessage={emptyMessage}
                productId={modalProductId}
                modalIsOpen={isSimilarProductsOpen}
                onModalClose={handleRelatedProductsModalClose}
            />
        </>
    );
};
export default withProductContext(RelatedProductsButton);
